import React from 'react'
import { authRoles } from '../../auth/authRoles'

const klientListRoutes = [
    {
        path: '/klientList/klientList',
        component: React.lazy(() => import('./KlientList')),
        auth: authRoles.admin,
    },
    {
        path: '/klientList/recipietnList',
        component: React.lazy(() => import('./RecipientList')),
        auth: authRoles.admin,
    },
]

export default klientListRoutes
